import { CompanyAvatarView } from "./components/CompanyAvatarView";
import { getCompanyAvatarSrc } from "./helpers/getCompanyAvatarSrc";
import { getCompanyInitial } from "./helpers/getCompanyInitial";

export { EditableCompanyAvatar } from "./components/EditableCompanyAvatar";

type CompanyAvatarProps = {
  company?: {
    businessName?: string | null;
    name?: string | null;
    avatar?: string | null;
    logoUrl?: string | null;
    avatarUrl?: string | null;
    imageUrl?: string | null;
    logo?: string | null;
  } | null;
  size?: number;
};

export const CompanyAvatar = ({ company, size = 48 }: CompanyAvatarProps) => {
  const src = getCompanyAvatarSrc(company);
  const initial = getCompanyInitial(company);
  const alt = company?.businessName || company?.name || "Company";

  return <CompanyAvatarView src={src} initial={initial} size={size} alt={alt} />;
};
